/**
 * Web entry point using react-native-web
 */

import 'react-native-gesture-handler';
import { AppRegistry } from 'react-native';
import App from './App';
import appConfig from './app.json';
import { injectAppFontsOnce } from './web/injectAppFontsWeb';
import { injectHomeCarouselCssOnce } from './web/injectHomeCarouselCssWeb';

// ---- react-native-vector-icons (WEB) ----
// Web needs @font-face declarations for each icon font family used.
// We load the .ttf files through webpack (asset/resource) and inject the CSS once.
import AntDesignFont from '@react-native-vector-icons/ant-design/fonts/AntDesign.ttf';
import EntypoFont from '@react-native-vector-icons/entypo/fonts/Entypo.ttf';
import FeatherFont from '@react-native-vector-icons/feather/fonts/Feather.ttf';
import FontAwesomeFont from '@react-native-vector-icons/fontawesome/fonts/FontAwesome.ttf';
import FontAwesome6BrandsFont from '@react-native-vector-icons/fontawesome6/fonts/FontAwesome6_Brands.ttf';
import FontAwesome6RegularFont from '@react-native-vector-icons/fontawesome6/fonts/FontAwesome6_Regular.ttf';
import FontAwesome6SolidFont from '@react-native-vector-icons/fontawesome6/fonts/FontAwesome6_Solid.ttf';
import FoundationFont from '@react-native-vector-icons/foundation/fonts/Foundation.ttf';
import IoniconsFont from '@react-native-vector-icons/ionicons/fonts/Ionicons.ttf';
import MaterialDesignIconsFont from '@react-native-vector-icons/material-design-icons/fonts/MaterialDesignIcons.ttf';
import MaterialIconsFont from '@react-native-vector-icons/material-icons/fonts/MaterialIcons.ttf';
import SimpleLineIconsFont from '@react-native-vector-icons/simple-line-icons/fonts/SimpleLineIcons.ttf';
import ZocialFont from '@react-native-vector-icons/zocial/fonts/Zocial.ttf';

function injectIconFontCssOnce() {
  if (typeof document === 'undefined') return;
  const STYLE_ID = 'rn-vector-icons-fonts';
  if (document.getElementById(STYLE_ID)) return;

  const fontFace = (fontFamily, src, extra = '') => {
    const family = JSON.stringify(fontFamily);
    const url = JSON.stringify(src);
    return `@font-face{font-family:${family};src:url(${url});${extra}}`;
  };

  const css = [
    // RNVI v13 web uses each icon set's `postScriptName` as fontFamily (see create-icon-set.js).
    fontFace('AntDesign', AntDesignFont),
    fontFace('anticon', AntDesignFont),
    fontFace('Entypo', EntypoFont),
    fontFace('Feather', FeatherFont),
    fontFace('FontAwesome', FontAwesomeFont),
    fontFace('Foundation', FoundationFont),
    fontFace('fontcustom', FoundationFont),
    fontFace('Ionicons', IoniconsFont),
    fontFace('MaterialDesignIcons', MaterialDesignIconsFont),
    fontFace('MaterialCommunityIcons', MaterialDesignIconsFont),
    fontFace('MaterialIcons-Regular', MaterialIconsFont),
    fontFace('SimpleLineIcons', SimpleLineIconsFont),
    fontFace('Zocial', ZocialFont),
    fontFace('FontAwesome6Free-Regular', FontAwesome6RegularFont),
    fontFace('FontAwesome6Free-Solid', FontAwesome6SolidFont),
    fontFace('FontAwesome6Brands-Regular', FontAwesome6BrandsFont),
    // Legacy aliases (older web shims / human-readable names)
    fontFace('Material Icons', MaterialIconsFont),
    fontFace('MaterialIcons', MaterialIconsFont),
    fontFace('Material Design Icons', MaterialDesignIconsFont),
    fontFace('simple-line-icons', SimpleLineIconsFont),
    fontFace('zocial', ZocialFont),
    fontFace('FontAwesome6_Brands', FontAwesome6BrandsFont),
    fontFace('FontAwesome6_Regular', FontAwesome6RegularFont),
    fontFace('FontAwesome6_Solid', FontAwesome6SolidFont),
  ].join('\n');

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
}

injectIconFontCssOnce();

// ---- App UI fonts (assets/fonts) — same webpack asset/resource + @font-face pattern ----
injectAppFontsOnce();

// ---- HomeCarousel scroll-snap CSS (RNW drops snapToOffsets silently) ----
injectHomeCarouselCssOnce();

const appName = appConfig.name || 'App';

AppRegistry.registerComponent(appName, () => App);

AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('react-root'),
});
